export default __webpack_public_path__ + "static/media/default.7a10bf02.svg";